(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('ContractsController', ContractsController);

  /* ngInject */
  function ContractsController($stateParams, branchService, contractService, contractStatuses, departmentService, sessionService, vendorService) {
    const vm = this;

    vm.branchFilter = null;
    vm.branches = [];
    vm.contracts = [];
    vm.contractStatuses = contractStatuses;
    vm.currentPage = $stateParams.currentPage || 1;
    vm.departmentFilter = null;
    vm.departments = [];
    vm.descriptionFilter = null;
    vm.filterResults = filterResults;
    vm.loading = false;
    vm.pageChange = pageChange;
    vm.statusFilter = null;
    vm.totalCount = null;
    vm.vendorFilter = null;
    vm.vendors = [];

    activate();

    function activate() {
      getBranches();
      getContracts();
      getDepartments();
      getVendors();
    }

    function filterResults() {
      vm.contracts = [];
      vm.currentPage = 1;
      getContracts();
    }

    function getBranches() {
      branchService(sessionService.getAuthToken()).query(response => vm.branches = response);
    }

    function getContracts() {
      vm.loading = true;

      let queryParams = {
        'q[branch_id_in]': vm.branchFilter,
        'q[department_id_in]': vm.departmentFilter,
        'q[description_cont]': vm.descriptionFilter,
        'q[status_eq]': vm.statusFilter,
        'q[vendor_id_in]': vm.vendorFilter,
        page: vm.currentPage
      };

      contractService(sessionService.getAuthToken()).query(queryParams, response => {
        vm.loading = false;
        vm.contracts = response.data;
        vm.totalCount = parseInt(response.headers['x-total']);
      }, _ => {
        vm.loading = false;
      });
    }

    function getDepartments() {
      departmentService(sessionService.getAuthToken()).query(response => vm.departments = response);
    }

    function getVendors() {
      vendorService(sessionService.getAuthToken()).query(response => vm.vendors = response.data);
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.contracts = [];
      vm.currentPage = newPageNumber;
      getContracts();
    }
  }
})();
